<template>
    <div>
    <v-card width="150" height="200" class="mb-3"  elevation="4" v-for="obj in papers" :key="obj.id">
        <a href="" @click="getEpaper(obj.id)">
        <v-img
            :src="$urlpath+obj.thumbnail"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="200px"
        >
            <v-card-title class="caption">{{obj.postdate|myDate}}</v-card-title>
        </v-img>
        </a>
    </v-card>
        </div>
</template>

<script>
import Mainaxios from '../Api'
  export default {
    name: 'Cards',
    data: () => ({
        papers:[],
      
    }),
    created () {
        this.fetchData()
    },
    methods:{
        async fetchData(){
            await Mainaxios.get("api/fetchEpapers").then(({data}) => (this.papers = data));
        },
        getEpaper(id){
            this.$router.push('/epaper/'+id)
        }
    }
  }
</script>
